import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { areaOfLawService, AreaOfLawDropdownItem } from '../../Services/AreaOfLawService';

interface AreaOfLawState {
  dropdownItems: AreaOfLawDropdownItem[];
  loading: boolean;
  error: string | null;
}

const initialState: AreaOfLawState = {
  dropdownItems: [],
  loading: false,
  error: null,
};

export const fetchAreaOfLawDropdown = createAsyncThunk(
  'areaOfLaw/fetchDropdown',
  async (_, { rejectWithValue }) => {
    try {
      const response = await areaOfLawService.getDropdownAreaOfLaw();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch area of law');
    }
  }
);

const areaOfLawSlice = createSlice({
  name: 'areaOfLaw',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAreaOfLawDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAreaOfLawDropdown.fulfilled, (state, action) => {
        state.loading = false;
        state.dropdownItems = action.payload as any;
      })
      .addCase(fetchAreaOfLawDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default areaOfLawSlice.reducer;
